// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
// `.env.ts` is generated by the `npm run env` command
// `npm run env` exposes environment variables as JSON for any usage you might
// want, like displaying the version or getting extra config from your CI bot, etc.
// This is useful for granularity you might need beyond just the environment.
// Note that as usual, any environment variables you expose through it will end up in your
// bundle, and you should not use it for any sensitive information like passwords or keys.
import { env } from './.env';
export const environment = {
  production: false,
  hmr: false,
  version: env.npm_package_version + '-dev',
  serverUrl: '',
  defaultLanguage: 'EN',
  supportedLanguages: ['EN', 'FR', 'DE', 'IT', 'ES', 'PT', 'RU', 'ZH', 'AR', 'HI', 'JA'],
  BaseURL: 'https://staging-admin.seychelles.com',
  adminBaseURL: 'https://staging-admin.seychelles.com',
  apiBaseURL:
    'https://staging-api.seychelles.com/api/v1/' +
    (localStorage.getItem('language') === null ? 'en' : localStorage.getItem('language').toLowerCase()),
  apiSearchBaseURL: 'https://staging-api.seychelles.com/api/v1/',
  crowdriffBaseURL: 'https://staging-api.seychelles.com/api/v1/',
  weatherURL: 'https://api.openweathermap.org/',
  weatherImageURL: 'http://openweathermap.org/',
  cdnBaseURL: 'https://cdn.parrapi.com/',
  sustainabilityId: '1138',
  cultureId: '2736',
  destinationId: '1225',
  worcationId: '729',
  specialInterestId: '346',
  divingId: '279',
  fishingId: '278',
  romanceId: '277',
  sailingId: '276',
  natureId: '275',
  imageOldurl: 'https://staging-admin.seychelles.com/sites/default/files/',
  imageNewurl: 'https://fr-par-1.linodeobjects.com/seychelles.com/Staging-Destination-Assets/public/',
  imageOldBlogDetail: 'http://staging-admin.seychelles.com/sites/default/files/',
  chatbotBaseURL: 'https://stb-cognitive-insights-uat.cglense.ai',
  gtmContainerId: 'GTM-PJ4WJGJB',
};
